/**
 * Chatbot Domain Types
 *
 * Additional TypeScript types for the chatbot domain.
 */
export const defaultChatbotConfig = {
    typingDelayMin: 1500,
    typingDelayMax: 2500,
    sentStatusDelay: 300,
    maxMessages: 100,
};
export const emptyConversation = {
    messages: [],
    isTyping: false,
    conversationId: null,
};
